import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTranslatedText } from "../../../utils/commons";
import "./staticDropdownSelect.scss";

const StaticDropdownSelectComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, label, required, visible, data, uischema, path } = props;
  const translated = uischema?.translated || false;

  const { childList = [], selection = "single" } = uischema.options || {};

  const [selected, setSelected] = useState(undefined);

  // Format options for dropdown if needed
  const formatOptions = useCallback(
    (options) =>
      options.map((option) => {
        const text = option.displayText || option.label || option.name;
        return {
          id: option.id || option.value,
          displayText: translated ? getTranslatedText(t, text, text) : text,
        };
      }),
    [t, translated]
  );

  // Initialize selected option if `data` is provided
  useEffect(() => {
    if (data) {
      if (selection === "single") {
        // For single selection
        const formattedOptions = formatOptions(childList);
        const selectedOption = formattedOptions.find((option) => option.id === data);
        if (selectedOption) {
          setSelected([selectedOption]);
        }
      } else {
        // For multiple selection
        if (Array.isArray(data) && data.length > 0) {
          const formattedOptions = formatOptions(childList);
          const selectedOptions = data
            .map((id) => formattedOptions.find((option) => option.id === id))
            .filter(Boolean);
          if (selectedOptions.length > 0) {
            setSelected(selectedOptions);
          }
        }
      }
    } else {
      setSelected(undefined);
    }
  }, [data, childList, selection, formatOptions]);

  // Handle selection change
  const handleSelectValue = (val) => {
    if (val && val.length > 0) {
      setSelected(val);

      if (selection === "single") {
        // For single selection, pass the ID of the first selected item
        handleChange(path, val[0].id);
      } else {
        // For multiple selection, pass an array of IDs from all selected items
        const selectedIds = val.map((item) => item.id);
        handleChange(path, selectedIds);
      }
    } else {
      setSelected(undefined);
      handleChange(path, selection === "single" ? null : []);
    }
  };

  if (!visible) return null;

  return (
    <div className="dropdown-select-component multiple-select-wrap static-dropdown">
      <Dropdown
        childList={formatOptions(childList)}
        selection={selection}
        disabled={uischema?.options?.disabled}
        selectedValue={selected}
        isRequired={required}
        setSelectedValue={handleSelectValue}
        placeholder={getTranslatedText(
          t,
          uischema?.placeholder,
          uischema?.placeholder
        )}
        label={getTranslatedText(t, label, label)}
      />
    </div>
  );
};

export const StaticDropdownSelectControl = withJsonFormsMultiEnumProps(
  StaticDropdownSelectComponent
);
